import TagManager from 'react-gtm-module';
import { GTM_ID } from '../config';

const initializeGTM = () => {
    if (!GTM_ID) return;
    TagManager.initialize({ gtmId: GTM_ID });
};

export default initializeGTM;